import * as z from "zod";

export const getWarrantyRegistrationsCount = {
  name: "getWarrantyRegistrationsCount" as const,
  input: z.object({
    filters: z.record(z.string(), z.string()).nullish(),
    search: z.string().nullish(),
    merchantTimezone: z.string().nullish(),
  }),
  output: z.object({ total: z.number() }),
};
